import { useQuery } from '@tanstack/react-query';
import { getLeaderboard } from '../services/gameService';

export interface LeaderboardEntry {
  user_email: string;
  nickname: string;
  total_score: number;
  games_played: number;
  high_score: number;
  average_score: number;
}

export const useLeaderboard = (gameType?: string) => {
  const { data: leaderboard, isLoading, error } = useQuery({
    queryKey: ['leaderboard', gameType],
    queryFn: () => getLeaderboard(gameType),
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
  });

  return { 
    leaderboard: leaderboard || [], 
    isLoading, 
    error: error ? (error as Error).message : null 
  };
}; 